import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { change } from 'redux-form';
import { orderUpdate } from '../../../../../../../redux/actions/order/orderActions';
import Toastr from '../../../../../../../itrust_common/components/Toastr';
import { humanize } from '../../../../../../../itrust_common/components/HelperFunctions';

export default function SyncMemberBenifit(props) {
  const { wrapperClasses } = props;
  const dispatch = useDispatch();

  const syncItems = useSelector(state => state.visionInsuranceMapping?.syncItems || []);
  const loading = useSelector(state => state.visionInsuranceMapping?.loading);
  const order = useSelector(state => state.order?.order || {});

  const [localCopays, setLocalCopays] = useState({});
  const [localAllowances, setLocalAllowances] = useState({});
  const [localDiscounts, setLocalDiscounts] = useState({});

  useEffect(() => {
    const initialCopays = {};
    const initialAllowances = {};
    const initialDiscounts = {};
    syncItems.forEach((item, index) => {
      initialCopays[index] = item.prefill?.copay ?? '';
      initialAllowances[index] = item.prefill?.allowance ?? '';
      const pDiscountType = item.prefill?.discount_type === 'percentage' ? 'percentage' : 
                            (item.prefill?.discount_type === 'cash' || item.prefill?.discount_type === 'amount' ? 'cash' : 'percentage');
      initialDiscounts[index] = {
        type: pDiscountType,
        value: item.prefill?.discount_value ?? ''
      };
    });
    setLocalCopays(initialCopays);
    setLocalAllowances(initialAllowances);
    setLocalDiscounts(initialDiscounts);
  }, [syncItems]);

  const handleCopayChange = (e, index) => {
    const val = e.target.value;
    setLocalCopays(prev => ({ ...prev, [index]: val }));
  };

  const handleAllowanceChange = (e, index) => {
    const val = e.target.value;
    setLocalAllowances(prev => ({ ...prev, [index]: val }));
  };

  const handleDiscountChange = (index, type, val) => {
    setLocalDiscounts(prev => ({ ...prev, [index]: { type, value: val } }));
  };

  const orderProcedureFormValues = useSelector(state => state.form?.orderProcedureForm?.values);
  const orderEyeglassFormValues = useSelector(state => state.form?.orderEyeglassForm?.values);
  const orderContactLensFormValues = useSelector(state => state.form?.orderContactLensForm?.values);

  const handleConfirmAll = () => {
    let applied = false;

    // Clone order attributes to build the update request body
    const updatedOrder = {
      id: order.id,
      procedures_attributes: order.procedures_attributes ? JSON.parse(JSON.stringify(order.procedures_attributes)) : [],
      eyeglasses_attributes: order.eyeglasses_attributes ? JSON.parse(JSON.stringify(order.eyeglasses_attributes)) : [],
      contact_lenses_attributes: order.contact_lenses_attributes ? JSON.parse(JSON.stringify(order.contact_lenses_attributes)) : []
    };

    // Helper to update both active forms (for instant UI feedback) and the payload to save
    const setField = (formName, fieldPath, val) => {
      if (val !== undefined && val !== null) {
        dispatch(change(formName, fieldPath, val));
        applied = true;
      }
    };

    syncItems.forEach((item, index) => {
      const prefill = item.prefill || {};
      
      let copayValue = localCopays[index];
      if (copayValue === '') copayValue = null;
      else if (copayValue !== undefined && copayValue !== null) copayValue = Number(copayValue);
      else copayValue = prefill.copay;

      let allowanceValue = localAllowances[index];
      if (allowanceValue === '') allowanceValue = null;
      else if (allowanceValue !== undefined && allowanceValue !== null) allowanceValue = Number(allowanceValue);
      else allowanceValue = prefill.allowance;

      let discountType = localDiscounts[index]?.type || prefill.discount_type || 'percentage';
      if (discountType === 'amount') discountType = 'cash';
      
      let discountValue = localDiscounts[index]?.value;
      if (discountValue === '') discountValue = null;
      else if (discountValue !== undefined && discountValue !== null) discountValue = Number(discountValue);
      else discountValue = prefill.discount_value;

      const type = item.type || item.category;

      if (type === 'procedure') {
        const procedureId = item.settings_id || item.resource_id;
        let matched = false;

        const updateProc = (proc) => {
          if (copayValue !== undefined && copayValue !== null) proc.copay = copayValue;
          if (allowanceValue !== undefined && allowanceValue !== null) proc.allowance = allowanceValue;
          if (discountValue !== undefined && discountValue !== null) {
            proc.discount_type = discountType;
            if (discountType === 'percentage') { proc.percentage_discount = discountValue; proc.cash_discount = null; }
            else { proc.cash_discount = discountValue; proc.percentage_discount = null; }
          }
        };

        const updateProcForm = (index2) => {
          setField('orderProcedureForm', `procedures_attributes[${index2}].copay`, copayValue);
          setField('orderProcedureForm', `procedures_attributes[${index2}].allowance`, allowanceValue);
          if (discountValue !== undefined && discountValue !== null) {
            setField('orderProcedureForm', `procedures_attributes[${index2}].discount_type`, discountType);
            if (discountType === 'percentage') {
              setField('orderProcedureForm', `procedures_attributes[${index2}].percentage_discount`, discountValue);
              setField('orderProcedureForm', `procedures_attributes[${index2}].cash_discount`, null);
            } else {
              setField('orderProcedureForm', `procedures_attributes[${index2}].cash_discount`, discountValue);
              setField('orderProcedureForm', `procedures_attributes[${index2}].percentage_discount`, null);
            }
          }
        };

        updatedOrder.procedures_attributes.forEach((proc) => {
          if (proc.settings_procedure_id === procedureId) {
            updateProc(proc);
            matched = true;
            applied = true;
          }
        });
        if (!matched && updatedOrder.procedures_attributes.length === 1) {
          updateProc(updatedOrder.procedures_attributes[0]);
          applied = true;
        }

        if (orderProcedureFormValues?.procedures_attributes) {
          let formMatched = false;
          orderProcedureFormValues.procedures_attributes.forEach((proc, index2) => {
            if (proc.settings_procedure_id === procedureId) {
              updateProcForm(index2);
              formMatched = true;
            }
          });
          if (!formMatched && orderProcedureFormValues.procedures_attributes.length === 1) {
            updateProcForm(0);
          }
        }
      } else if (type === 'frame') {
        const frameId = item.settings_id || item.resource_id;
        let matched = false;

        const updateEg = (eg) => {
          if (copayValue !== undefined && copayValue !== null) eg.frame_copay = copayValue;
          if (allowanceValue !== undefined && allowanceValue !== null) eg.frame_allowance = allowanceValue;
          if (discountValue !== undefined && discountValue !== null) {
            eg.frame_discount_type = discountType;
            if (discountType === 'percentage') { eg.frame_percentage_discount = discountValue; eg.frame_cash_discount = null; }
            else { eg.frame_cash_discount = discountValue; eg.frame_percentage_discount = null; }
          }
        };

        const updateEgForm = (index2) => {
          setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].frame_copay`, copayValue);
          setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].frame_allowance`, allowanceValue);
          if (discountValue !== undefined && discountValue !== null) {
            setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].frame_discount_type`, discountType);
            if (discountType === 'percentage') {
              setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].frame_percentage_discount`, discountValue);
              setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].frame_cash_discount`, null);
            } else {
              setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].frame_cash_discount`, discountValue);
              setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].frame_percentage_discount`, null);
            }
          }
        };

        updatedOrder.eyeglasses_attributes.forEach((eg) => {
          if (eg.frame_id === frameId) {
            updateEg(eg);
            matched = true;
            applied = true;
          }
        });
        if (!matched && updatedOrder.eyeglasses_attributes.length === 1) {
          updateEg(updatedOrder.eyeglasses_attributes[0]);
          applied = true;
        }

        if (orderEyeglassFormValues?.eyeglasses_attributes) {
          let formMatched = false;
          orderEyeglassFormValues.eyeglasses_attributes.forEach((eg, index2) => {
            if (eg.frame_id === frameId) {
              updateEgForm(index2);
              formMatched = true;
            }
          });
          if (!formMatched && orderEyeglassFormValues.eyeglasses_attributes.length === 1) {
            updateEgForm(0);
          }
        }
      } else if (type === 'lens' || type === 'lens_type') {
        const lensTypeId = item.settings_id || item.resource_id;
        let matched = false;

        const updateLt = (eg, lt) => {
          if (allowanceValue !== undefined && allowanceValue !== null) eg.lens_allowance = allowanceValue;
          if (copayValue !== undefined && copayValue !== null) lt.copay = copayValue;
          if (discountValue !== undefined && discountValue !== null) {
            lt.discount_type = discountType;
            if (discountType === 'percentage') { lt.percentage_discount = discountValue; lt.cash_discount = null; }
            else { lt.cash_discount = discountValue; lt.percentage_discount = null; }
          }
        };

        const updateLtForm = (index2, ltIndex) => {
          setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].lens_allowance`, allowanceValue);
          setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].lens_types_attributes[${ltIndex}].copay`, copayValue);
          if (discountValue !== undefined && discountValue !== null) {
            setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].lens_types_attributes[${ltIndex}].discount_type`, discountType);
            if (discountType === 'percentage') {
              setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].lens_types_attributes[${ltIndex}].percentage_discount`, discountValue);
              setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].lens_types_attributes[${ltIndex}].cash_discount`, null);
            } else {
              setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].lens_types_attributes[${ltIndex}].cash_discount`, discountValue);
              setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].lens_types_attributes[${ltIndex}].percentage_discount`, null);
            }
          }
        };

        updatedOrder.eyeglasses_attributes.forEach((eg) => {
          if (eg.lens_types_attributes) {
            eg.lens_types_attributes.forEach((lt) => {
              if (lt.settings_eyeglass_lens_type_id === lensTypeId) {
                updateLt(eg, lt);
                matched = true;
                applied = true;
              }
            });
          }
        });
        if (!matched && updatedOrder.eyeglasses_attributes.length === 1) {
          const eg = updatedOrder.eyeglasses_attributes[0];
          if (eg.lens_types_attributes) {
            eg.lens_types_attributes.forEach((lt) => {
              updateLt(eg, lt);
            });
          }
          applied = true;
        }

        if (orderEyeglassFormValues?.eyeglasses_attributes) {
          let formMatched = false;
          orderEyeglassFormValues.eyeglasses_attributes.forEach((eg, index2) => {
            if (eg.lens_types_attributes) {
              eg.lens_types_attributes.forEach((lt, ltIndex) => {
                if (lt.settings_eyeglass_lens_type_id === lensTypeId) {
                  updateLtForm(index2, ltIndex);
                  formMatched = true;
                }
              });
            }
          });
          if (!formMatched && orderEyeglassFormValues.eyeglasses_attributes.length === 1) {
            if (orderEyeglassFormValues.eyeglasses_attributes[0].lens_types_attributes) {
              orderEyeglassFormValues.eyeglasses_attributes[0].lens_types_attributes.forEach((lt, ltIndex) => {
                updateLtForm(0, ltIndex);
              });
            }
          }
        }
      } else if (type === 'lens_material') {
        const materialId = item.settings_id || item.resource_id;
        let matched = false;

        const updateEgMat = (eg) => {
          if (allowanceValue !== undefined && allowanceValue !== null) eg.lens_allowance = allowanceValue;
          if (copayValue !== undefined && copayValue !== null) eg.lens_material_copay = copayValue;
          if (discountValue !== undefined && discountValue !== null) {
            eg.lens_material_discount_type = discountType;
            if (discountType === 'percentage') { eg.lens_material_percentage_discount = discountValue; eg.lens_material_cash_discount = null; }
            else { eg.lens_material_cash_discount = discountValue; eg.lens_material_percentage_discount = null; }
          }
        };

        const updateEgMatForm = (index2) => {
          setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].lens_allowance`, allowanceValue);
          setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].lens_material_copay`, copayValue);
          if (discountValue !== undefined && discountValue !== null) {
            setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].lens_material_discount_type`, discountType);
            if (discountType === 'percentage') {
              setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].lens_material_percentage_discount`, discountValue);
              setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].lens_material_cash_discount`, null);
            } else {
              setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].lens_material_cash_discount`, discountValue);
              setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].lens_material_percentage_discount`, null);
            }
          }
        };

        updatedOrder.eyeglasses_attributes.forEach((eg) => {
          if (eg.lens_material_id === materialId) {
            updateEgMat(eg);
            matched = true;
            applied = true;
          }
        });
        if (!matched && updatedOrder.eyeglasses_attributes.length === 1) {
          updateEgMat(updatedOrder.eyeglasses_attributes[0]);
          applied = true;
        }

        if (orderEyeglassFormValues?.eyeglasses_attributes) {
          let formMatched = false;
          orderEyeglassFormValues.eyeglasses_attributes.forEach((eg, index2) => {
            if (eg.lens_material_id === materialId) {
              updateEgMatForm(index2);
              formMatched = true;
            }
          });
          if (!formMatched && orderEyeglassFormValues.eyeglasses_attributes.length === 1) {
            updateEgMatForm(0);
          }
        }
      } else if (type === 'addon' || type === 'lens_addons') {
        const updateAd = (ad) => {
          if (copayValue !== undefined && copayValue !== null) ad.copay = copayValue;
          if (discountValue !== undefined && discountValue !== null) {
            ad.discount_type = discountType;
            if (discountType === 'percentage') { ad.percentage_discount = discountValue; ad.cash_discount = null; }
            else { ad.cash_discount = discountValue; ad.percentage_discount = null; }
          }
          applied = true;
        };
        const updateAdForm = (index2, adIndex) => {
          setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].eyeglass_addons_attributes[${adIndex}].copay`, copayValue);
          if (discountValue !== undefined && discountValue !== null) {
            setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].eyeglass_addons_attributes[${adIndex}].discount_type`, discountType);
            if (discountType === 'percentage') {
              setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].eyeglass_addons_attributes[${adIndex}].percentage_discount`, discountValue);
              setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].eyeglass_addons_attributes[${adIndex}].cash_discount`, null);
            } else {
              setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].eyeglass_addons_attributes[${adIndex}].cash_discount`, discountValue);
              setField('orderEyeglassForm', `eyeglasses_attributes[${index2}].eyeglass_addons_attributes[${adIndex}].percentage_discount`, null);
            }
          }
        };

        updatedOrder.eyeglasses_attributes.forEach((eg) => {
          if (eg.eyeglass_addons_attributes) {
            eg.eyeglass_addons_attributes.forEach((ad) => {
              updateAd(ad);
            });
          }
        });

        if (orderEyeglassFormValues?.eyeglasses_attributes) {
          orderEyeglassFormValues.eyeglasses_attributes.forEach((eg, index2) => {
            if (eg.eyeglass_addons_attributes) {
              eg.eyeglass_addons_attributes.forEach((ad, adIndex) => {
                updateAdForm(index2, adIndex);
              });
            }
          });
        }
      } else if (type === 'contact_lens' || type === 'contact' || type === 'material') {
        const isOD = (item.eye === 'OD' || String(item.label).toUpperCase() === 'OD');
        const isOS = (item.eye === 'OS' || String(item.label).toUpperCase() === 'OS');

        const updateCl = (cl) => {
          if (isOD) {
            if (copayValue !== undefined && copayValue !== null) cl.od_copay = copayValue;
            if (discountValue !== undefined && discountValue !== null) {
              cl.od_discount_type = discountType;
              if (discountType === 'percentage') { cl.od_percentage_discount = discountValue; cl.od_cash_discount = null; }
              else { cl.od_cash_discount = discountValue; cl.od_percentage_discount = null; }
            }
          } else if (isOS) {
            if (copayValue !== undefined && copayValue !== null) cl.os_copay = copayValue;
            if (discountValue !== undefined && discountValue !== null) {
              cl.os_discount_type = discountType;
              if (discountType === 'percentage') { cl.os_percentage_discount = discountValue; cl.os_cash_discount = null; }
              else { cl.os_cash_discount = discountValue; cl.os_percentage_discount = null; }
            }
          } else {
            if (copayValue !== undefined && copayValue !== null) cl.od_copay = copayValue;
            if (copayValue !== undefined && copayValue !== null) cl.os_copay = copayValue;
            if (copayValue !== undefined && copayValue !== null) cl.material_copay = copayValue;
            if (discountValue !== undefined && discountValue !== null) {
              cl.od_discount_type = discountType;
              cl.os_discount_type = discountType;
              if (discountType === 'percentage') { 
                cl.od_percentage_discount = discountValue; cl.od_cash_discount = null;
                cl.os_percentage_discount = discountValue; cl.os_cash_discount = null;
              } else {
                cl.od_cash_discount = discountValue; cl.od_percentage_discount = null;
                cl.os_cash_discount = discountValue; cl.os_percentage_discount = null;
              }
            }
          }
          if (allowanceValue !== undefined && allowanceValue !== null) cl.allowance = allowanceValue;
          applied = true;
        };

        const updateClForm = (index2) => {
          if (isOD) {
            setField('orderContactLensForm', `contact_lenses_attributes[${index2}].od_copay`, copayValue);
            if (discountValue !== undefined && discountValue !== null) {
              setField('orderContactLensForm', `contact_lenses_attributes[${index2}].od_discount_type`, discountType);
              if (discountType === 'percentage') {
                setField('orderContactLensForm', `contact_lenses_attributes[${index2}].od_percentage_discount`, discountValue);
                setField('orderContactLensForm', `contact_lenses_attributes[${index2}].od_cash_discount`, null);
              } else {
                setField('orderContactLensForm', `contact_lenses_attributes[${index2}].od_cash_discount`, discountValue);
                setField('orderContactLensForm', `contact_lenses_attributes[${index2}].od_percentage_discount`, null);
              }
            }
          } else if (isOS) {
            setField('orderContactLensForm', `contact_lenses_attributes[${index2}].os_copay`, copayValue);
            if (discountValue !== undefined && discountValue !== null) {
              setField('orderContactLensForm', `contact_lenses_attributes[${index2}].os_discount_type`, discountType);
              if (discountType === 'percentage') {
                setField('orderContactLensForm', `contact_lenses_attributes[${index2}].os_percentage_discount`, discountValue);
                setField('orderContactLensForm', `contact_lenses_attributes[${index2}].os_cash_discount`, null);
              } else {
                setField('orderContactLensForm', `contact_lenses_attributes[${index2}].os_cash_discount`, discountValue);
                setField('orderContactLensForm', `contact_lenses_attributes[${index2}].os_percentage_discount`, null);
              }
            }
          } else {
            setField('orderContactLensForm', `contact_lenses_attributes[${index2}].od_copay`, copayValue);
            setField('orderContactLensForm', `contact_lenses_attributes[${index2}].os_copay`, copayValue);
            setField('orderContactLensForm', `contact_lenses_attributes[${index2}].material_copay`, copayValue);
            if (discountValue !== undefined && discountValue !== null) {
              setField('orderContactLensForm', `contact_lenses_attributes[${index2}].od_discount_type`, discountType);
              setField('orderContactLensForm', `contact_lenses_attributes[${index2}].os_discount_type`, discountType);
              if (discountType === 'percentage') {
                setField('orderContactLensForm', `contact_lenses_attributes[${index2}].od_percentage_discount`, discountValue);
                setField('orderContactLensForm', `contact_lenses_attributes[${index2}].od_cash_discount`, null);
                setField('orderContactLensForm', `contact_lenses_attributes[${index2}].os_percentage_discount`, discountValue);
                setField('orderContactLensForm', `contact_lenses_attributes[${index2}].os_cash_discount`, null);
              } else {
                setField('orderContactLensForm', `contact_lenses_attributes[${index2}].od_cash_discount`, discountValue);
                setField('orderContactLensForm', `contact_lenses_attributes[${index2}].od_percentage_discount`, null);
                setField('orderContactLensForm', `contact_lenses_attributes[${index2}].os_cash_discount`, discountValue);
                setField('orderContactLensForm', `contact_lenses_attributes[${index2}].os_percentage_discount`, null);
              }
            }
          }
          setField('orderContactLensForm', `contact_lenses_attributes[${index2}].allowance`, allowanceValue);
        };

        updatedOrder.contact_lenses_attributes.forEach((cl) => {
          updateCl(cl);
        });

        if (orderContactLensFormValues?.contact_lenses_attributes) {
          orderContactLensFormValues.contact_lenses_attributes.forEach((cl, index2) => {
            updateClForm(index2);
          });
        }
      }
    });

    if (applied) {
      dispatch(orderUpdate(updatedOrder, { include: '*' }));
      Toastr.handleShow(true, "Successfully prefilled and saved benefits.", 200);
      if (props.onClose) {
        props.onClose();
      }
    } else {
      Toastr.handleShow(false, "No matching form fields found to prefill", 400);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-4">
        <div className="spinner-border spinner-border-sm text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="position-relative">
      <div className="d-flex justify-content-between align-items-center px-4 py-2 border-bottom">
        <h6 className=" py-3 text-primary">Sync Copay Value</h6>
        <div className="d-flex align-items-center">
          {syncItems && syncItems.length > 0 && (
            <button
              type="button"
              className="btn btn-sm btn-primary py-1 px-3 mr-2"
              onClick={handleConfirmAll}
            >
              Confirm
            </button>
          )}
          {props.onClose && (
            <span className="font-size-24 pointer" onClick={props.onClose}>
              <i className="las la-times"></i>
            </span>
          )}
        </div>
      </div>
      <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto' }}>
        <table className={`table shadow-none mb-0 ${wrapperClasses}`}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Category</th>
              <th className='text-center'>Copay</th>
              <th className='text-center'>Allowance</th>
              <th className='text-center'>Discount</th>
            </tr>
          </thead>
          <tbody>
            {syncItems && syncItems.length > 0 ? (
              syncItems.map((item, index) => (
                <tr key={index}>
                  <td className="text-capitalize">{item.label}</td>
                  <td className="text-capitalize align-top">{humanize(item.type)}</td>
                  <td className='text-center'>
                    {item.prefill?.copay !== undefined ? (
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="mr-1">$</span>
                        <input
                          type="number"
                          className="form-control form-control-sm"
                          style={{ width: '50px' }}
                          value={localCopays[index] !== undefined ? localCopays[index] : ''}
                          onChange={(e) => handleCopayChange(e, index)}
                        />
                      </div>
                    ) : (
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="mr-1">$</span>
                        <input type="number" className="form-control form-control-sm" style={{ width: '50px' }} disabled />
                      </div>
                    )}
                  </td>
                  <td className='text-center'>
                    {item.prefill?.allowance !== undefined ? (
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="mr-1">$</span>
                        <input
                          type="number"
                          className="form-control form-control-sm"
                          style={{ width: '50px' }}
                          value={localAllowances[index] !== undefined ? localAllowances[index] : ''}
                          onChange={(e) => handleAllowanceChange(e, index)}
                        />
                      </div>
                    ) : (
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="mr-1">$</span>
                        <input type="number" className="form-control form-control-sm" style={{ width: '50px' }} disabled />
                      </div>
                    )}
                  </td>
                  <td className='text-center'>
                    {item.prefill?.discount_value !== undefined ? (
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="mr-1">%</span>
                        <input
                          type="number"
                          className="form-control form-control-sm"
                          style={{ width: '50px' }}
                          value={localDiscounts[index]?.value !== undefined ? localDiscounts[index]?.value : ''}
                          onChange={(e) => handleDiscountChange(index, 'percentage', e.target.value)}
                        />
                      </div>
                    ) : (
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="mr-1">%</span>
                        <input type="number" className="form-control form-control-sm" style={{ width: '50px' }} disabled />
                      </div>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr className="text-center py-3">
                <td colSpan={5}>No sync items found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
